module.exports = __webpack_public_path__ + "static/view_1-220adeed2225ec80497a04b0a89fd079.jpg";